(function($, Cobalt, undefined) {
    Cobalt.WidgetSettings = {
        initialize: function() {
            if ($(".body-cp-widgetsettings").length == 0) {
                return;
            }

            var useICE = $("#field-use-ice");
            if (useICE.length > 0) {
                var useIceIsChecked = useICE.is(":checked");
                var hostField = $("#form-field-host");
                var portField = $("#form-field-port");
                var jsonField = $("#form-field-json-url");
                if (!useIceIsChecked) {
                    hostField.hide();
                    portField.hide();
                    jsonField.show();
                }
                else {
                    hostField.show();
                    portField.show();
                    jsonField.hide();
                }

                useICE.change(function() {
                    hostField.toggle();
                    portField.toggle();
                    jsonField.toggle();
                });
            }
        }
    };
})(jQuery, Cobalt, undefined);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.WidgetSettings.js